import { createStore } from 'vuex';

import app from './modules/app';
import cart from './modules/cart';
import modals from './modules/modals';
import sellOrders from './modules/sellOrders';
import staticPages from './modules/staticPages';
import user from './modules/user';
// import discount from './modules/discount'

const debug = process.env.NODE_ENV !== 'production';

const store = createStore({
	modules: {
		app,
		modals,
		user,
		cart,
		staticPages,
		sellOrders,
		// discount
	},
	strict: debug,
});

export default store;
